var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 325 324.99999",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg88",
    width: 325,
    height: 325,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs52"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 660.07001,
    x2: 658.46002,
    y1: 6.5995998,
    y2: 108.78,
    gradientTransform: "translate(-45.255,0.35355)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2c2c2",
    offset: 0,
    id: "stop47"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f9f9f",
    offset: 1,
    id: "stop49"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 325,
    height: 325,
    ry: 5.6141963,
    fill: "#eeeeee",
    id: "rect54",
    style: {
      strokeWidth: 0.888187
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-351.352,68.249999)",
    id: "g78"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-16.343)",
    x: 398.76001,
    y: 178.75,
    width: 82.489998,
    height: 90.470001,
    ry: 8.3970003,
    fill: "#9f9f9f",
    id: "rect56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(16.321,538.14,-184.9)",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "g76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.19,
    y: 1.6497999,
    width: 107.83,
    height: 115.97,
    ry: 4.5962,
    fill: "url(#a)",
    strokeWidth: 5.398,
    id: "rect58",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.17265,0,0,0.17265,512.49,-6.3296)",
    fillRule: "evenodd",
    shapeRendering: "auto",
    strokeWidth: 13.071,
    id: "g74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 107.36,
    width: 491.10999,
    height: 450,
    color: "#000000",
    colorRendering: "auto",
    fill: "#cccccc",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    id: "rect60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 107.36,
    width: 491.10999,
    height: 210,
    color: "#000000",
    colorRendering: "auto",
    fill: "#ffffff",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    id: "rect62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 300,317.36 38.461,-53.538 60.531,-45.161 15.883,18.574 13.613,-38.684 8.2013,-2.9819 13.311,-28.209 180,180",
    color: "#000000",
    colorRendering: "auto",
    fill: "#cccccc",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "stroke"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,107.36)",
    d: "m 180,60 c 4.0931,16.475 7.7122,33.067 10.852,49.75 2.3826,12.661 4.4886,25.374 6.3164,38.127 l -22.064,-7.1602 -46.111,-29.416 5.3242,46.426 -1.6152,24.787 10.053,30.377 73.186,-11.756 84.061,-21.135 -47.801,-77.434 -9.6992,14.934 -27.125,-22.125 z",
    color: "#000000",
    colorRendering: "auto",
    fill: "#b3b3b3",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "stroke"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 420,347.36 81.899,-74.43 18.506,-9.6801 23.651,-44.189 25.944,-21.701 180,180",
    color: "#000000",
    colorRendering: "auto",
    fill: "#cccccc",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "stroke"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 570,197.36 35.939,80.913 v 30.11 30.11 l 22.459,19.467 c 6.5245,-6.4503 14.149,-11.785 22.444,-15.705 14.824,-7.0045 31.338,-9.3596 47.171,-13.622 6.4278,-1.7304 12.907,-3.8542 18.213,-7.8728 1.3517,-1.0236 2.6159,-2.1628 3.7742,-3.4011 h -30 l -40.521,-40.55 -29.856,-48.92 -10.253,8.8389 z",
    color: "#000000",
    colorRendering: "auto",
    fill: "#b3b3b3",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "stroke"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 420,557.36 c -0.41699,-9.6009 -8.8176,-17.609 17.125,-30.668 31.832,-16.024 125.9,-35.888 152.15,-59.984 19.427,-17.827 -70.415,-37.669 -55.019,-59.073 6.981,-9.7053 59.037,-19.969 82.146,-30.274 21.906,-9.768 15.141,-19.803 31.405,-29.975 15.709,-9.8256 68.35,-19.774 72.189,-30.025 -10.414,10.522 -68.834,20.403 -90,30 -22.338,10.128 -21.469,19.93 -49.431,29.484 -30.124,10.292 -89.142,20.553 -102.71,30.516 -28.413,20.869 46.863,42.6 16.202,60 -41.52,23.563 -149.34,43.294 -194.06,60 -30.904,11.544 -28.408,17.748 -30,30",
    color: "#000000",
    colorRendering: "auto",
    fill: "#ffffff",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "stroke"
    },
    id: "path72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImagePlaceholder);
export default __webpack_public_path__ + "static/media/No-Image-Placeholder.44c52418224f365c9d530cc1a3ec0078.svg";
export { ForwardRef as ReactComponent };